// @core/api/endpoints/knowledge/get_knowledge_base.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  KnowledgeBaseResponse,
} from '../../../types/knowledge';

const BASE_PATH = '/knowledge';

/**
 * Get knowledge base
 * Retrieves a knowledge base with its configuration and indexing statistics.
 */
export async function GetKnowledgeBase(
  base_id: string,
  options?: RequestOptions
): Promise<KnowledgeBaseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/knowledge/bases/:base_id`;
  requestPath = requestPath.replace(':base_id', encodeURIComponent(base_id));
  const requestOptions = options;
  return client.get<KnowledgeBaseResponse>(requestPath, { ...requestOptions });
}
